import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, IconButton, TableCell } from '@mui/material';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
// import EmailIcon from '@mui/icons-material/Email';
// import MailOutlineIcon from '@mui/icons-material/MailOutline';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { connect } from 'react-redux';
import Swal from "sweetalert2";

import DefaultTable from '../../../components/Table';
import appConfig from '../../../config/appConfig';
import * as emailConfigActions from '../../../store/actions/emailConfig';
import * as headerActions from '../../../store/actions/header';
import * as footerActions from '../../../store/actions/footer';
import CreateEmailConfiguration from './CreateEmailConfiguration';
import EditEmailConfiguration from './EditEmailConfiguration';
import { selectHeaderNameByCode, selectFooterNameByCode } from '../../../selectors/lookupSelectors';

const ViewEmailConfigurations = ({state, emailConfigs, 
        fetchHeaderConfigs, fetchFooterConfigs, fetchEmailConfigs, 
        resetEditEmailConfigData, resetCreateEmailConfigData, deleteEmailConfig }) => {
    const [activeMode, setActiveMode] = useState('list');
    const [emailConfigsData, setEmailConfigsData] = useState();
    const [paginationEmail, setPaginationEmail] = useState({ limit: 10, offset: 1 });
    const [selectedRowEmail, setSelectedRowEmail] = useState();
    const [isEmailConfigDeleted, setIsEmailConfigDeleted] = useState(false);
    

    useEffect(async () => {
        await fetchHeaderConfigs();
        await fetchFooterConfigs();
        await fetchEmailConfigs(paginationEmail.limit, paginationEmail.offset);
    }, []);

    useEffect(() => {
        fetchEmailConfigs(paginationEmail.limit, paginationEmail.offset);
    }, [paginationEmail, emailConfigs?.editEmailConfigData, emailConfigs?.createEmailConfigData])

    useEffect(() => {
        setEmailConfigsData(emailConfigs?.emailConfigs?.emailConfigs);
    }, [emailConfigs?.emailConfigs?.emailConfigs])    

      useEffect(() => {
        if (emailConfigs?.deleteEmailConfigData?.data?.status === 1 && isEmailConfigDeleted) {
          setIsEmailConfigDeleted(false);
          Swal.fire({
            icon: "success",
            button: false,
            showConfirmButton: false,
            timer: 2000,
            text: "Email Configuration deleted successfully",
          });
          setTimeout(() => {
            fetchEmailConfigs(paginationEmail.limit, 1,'','');
          }, 2000);
        }else if(emailConfigs?.deleteEmailConfigData?.data?.status === 0 && isEmailConfigDeleted){
          setIsEmailConfigDeleted(false);
          Swal.fire({
            icon: "error",
            button: false,
            showConfirmButton: false,
            timer: 2000,
            text: "Error, please try again later",
          });
        }
      }, [JSON.stringify(emailConfigs?.deleteEmailConfigData)])

    const handlePaginationEmail = (limit, offset) => {
        setPaginationEmail({ limit, offset });
    }

    // const handleDefaultEmail = (row) => {
    //     console.log('Set payload and Update call', row);
    // }

    const handleEditEmail = (row) => {
        resetEditEmailConfigData();
        setActiveMode('edit');
        setSelectedRowEmail(row);
    }

    const handleDeleteEmail = (row) => {
        const swalWithCustompButtons = Swal.mixin({
              customClass: {
                confirmButton: 'custom-ok-button',
                cancelButton: 'custom-cancel-button'
              },
              buttonsStyling: false
            })
        
            swalWithCustompButtons.fire({
              title: "",
              html: `Delete Email Configuration? <br/> <span style='font-size: 14px'}}> All Templates associated with this Email Configuration will be replaced by Default Email Configuration.</span>`,
              icon: 'warning',
              showCancelButton: true,
              cancelButtonText: 'Cancel',
              confirmButtonText: 'Delete',
              reverseButtons: true
            }).then((result) => {
              setIsEmailConfigDeleted(false);
              if (result.isConfirmed) {
                setIsEmailConfigDeleted(true);
                deleteEmailConfig(row);
              } else {
                setIsEmailConfigDeleted(false);
              }
            })
    }

    const renderCellsEmail = (row) => {
        return <>
            <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, fontWeight: row.defaultConfigFlag ? 'bold' : '' }}>
                {row.defaultConfigFlag ? `${row.name}(Default)` : row.name}
            </TableCell>
            <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, fontWeight: row.defaultConfigFlag ? 'bold' : '' }} >
                {row.code}
            </TableCell>
            <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, fontWeight: row.defaultConfigFlag ? 'bold' : '' }}>
                {row.headerConfigurationCode ? selectHeaderNameByCode(state, row.headerConfigurationCode) : '-'}
            </TableCell>
            <TableCell sx={{ fontFamily: appConfig.fontfamily, fontSize: appConfig.font16, fontWeight: row.defaultConfigFlag ? 'bold' : '' }}>
                {row.footerConfigurationCode ? selectFooterNameByCode(state, row.footerConfigurationCode) : '-'}
            </TableCell>
        </>
    }

    const renderActionButtonEmail = (row) => {
        return <div className='display-flex'>
            {/* <IconButton
                sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px' }}
                title={row?.isDefault ? 'Default Email Configuration' : 'Set as default'}
                aria-label={row?.isDefault ? 'default email configuration' : 'set as default email configuration'}
                size="small"
                onClick={() => {
                    handleDefaultEmail(row);
                }}
            >
                {
                    row?.isDefault ?
                        <EmailIcon sx={{ fontSize: 24, color: appConfig.colors.darkblue }} />
                        :
                        <MailOutlineIcon sx={{ fontSize: 24, color: appConfig.colors.darkblue }} />
                }
            </IconButton> */}
            <IconButton
                sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px', marginLeft: "20px" }}
                title='Edit Email Configuration'
                aria-label="edit email configuration"
                size="small"
                onClick={() => {
                    handleEditEmail(row);
                }}
            >
                <ModeEditOutlineOutlinedIcon />
            </IconButton>
            {!row?.defaultConfigFlag && <IconButton
                sx={{ border: `1px solid ${appConfig.colors.darkblue}`, padding: '2px', marginLeft: "20px" }}
                title='Delete Email Configuration'
                aria-label="delete email configuration"
                size="small"
                onClick={() => {
                    handleDeleteEmail(row);
                }}
            >
                <DeleteForeverOutlinedIcon sx={{ fontSize: 24, color: appConfig.colors.darkblue }} />
            </IconButton>}
        </div>
    }

    return <div>
        <Grid item md={12} xl={12} lg={12} sm={12} sx={{ mb: 1 }}>
            {
                activeMode === 'list' && 
                <DefaultTable
                    title='Email Configurations'
                    handlePagination={handlePaginationEmail}
                    headers={[
                        {
                            name: 'Name', sortEnabled: false
                        },
                        {
                            name: 'Code', sortEnabled: false
                        },
                        {
                            name: 'Header', sortEnabled: false
                        },
                        {
                            name: 'Footer', sortEnabled: false
                        }
                    ]}
                    hasAction
                    renderActionButton={renderActionButtonEmail}
                    data={emailConfigsData}
                    totalCount={emailConfigsData?.length}
                    currentPage={paginationEmail.offset}
                    currentLimit={paginationEmail.limit}
                    renderCustomCells
                    renderCells={renderCellsEmail}
                    isTableHeaderEnabled
                    tableHeaderCallback={() => { resetCreateEmailConfigData(); setActiveMode('create') }}
                    tableHeaderButtonText='Create Email Configurations'
                />
            }
            {
                activeMode === 'create' && 
                    <CreateEmailConfiguration 
                        showEmailConfigurations={() => setActiveMode('list')} 
                    />
            }
            {   
                activeMode === 'edit' && 
                    <EditEmailConfiguration 
                        emailConfigData={selectedRowEmail} 
                        showEmailConfigurations={() => setActiveMode('list')} 
                    />
            }
        </Grid>
    </div>
}

ViewEmailConfigurations.propTypes = {
    state: PropTypes.object.isRequired,
    emailConfigs: PropTypes.object.isRequired,
    fetchEmailConfigs: PropTypes.func.isRequired,
    fetchHeaderConfigs: PropTypes.func.isRequired,
    fetchFooterConfigs: PropTypes.func.isRequired,
    resetEditEmailConfigData: PropTypes.func.isRequired,
    resetCreateEmailConfigData: PropTypes.func.isRequired,
    deleteEmailConfig: PropTypes.func.isRequired,
}

const mapStateToProps = (state) => ({
    state,
    emailConfigs: state.emailConfig,
})

const mapDispatchToProps = (dispatch) => {
    return {
        fetchHeaderConfigs: () => dispatch(headerActions.getHeaderList('', '')),
        fetchFooterConfigs: () => dispatch(footerActions.getFooterList('', '')),
        fetchEmailConfigs: (limit, page) => dispatch(emailConfigActions.getEmailConfigList(limit, page)),
        resetEditEmailConfigData: () => dispatch(emailConfigActions.resetEditEmailConfigData()),
        resetCreateEmailConfigData: () => dispatch(emailConfigActions.resetCreateEmailConfigData()),
        deleteEmailConfig: (data) => dispatch(emailConfigActions.deleteEmailConfig(data))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewEmailConfigurations);